import { Link } from "@StarberryUtils";
import React from "react";
import {Col, Row, Container, Table } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby";

import  "./Owners.scss";
// import PropertyMap from "../PropertyMap/PropertyMap";
// import propImg04 from "../../../images/property-img04.jpg"
// import propImg05 from "../../../images/property-img05.jpg"
import fillImg01 from "../../../images/fill-img01.svg"
import noticeUnderline from "../../../images/notice-underline.svg"
// import propImg06 from "../../../images/property-img06.jpg"
// import propImg07 from "../../../images/property-img07.jpg"
import Map from '../../map/office-details-map'
import PropertyDetailsModal from "../../Play/property-details-video-modal"
import Availability from "./availability"
import HTMLParser from 'html-react-parser'
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";

import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import _ from "lodash"

import { inViewOptions } from '../../../components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import { Parking, Garden, Size, CouncilTax } from "../../../icons/icons";

const containerVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        ease: [0.33, 1, 0.68, 1],
        duration: 0.4
      }
    }
}
const fromLeft = {
    hidden: {
      opacity: 0,
      x: -40,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease: [0.33, 1, 0.68, 1],
        duration: 0.4
      }
    }
}
const fromRight = {
    hidden: {
      opacity: 0,
      x: 40,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease: [0.33, 1, 0.68, 1],
        duration: 0.4
      }
    }
}
const MotionRow = motion(Row)

// const SINGLE_AREA = gql`
// query GetAreaDetails ($Prop_Postcode: String!){
//     areaGuides (where:{Postcode_contains:$Prop_Postcode}) {
//         Title
//         Postcode
//         URL
//         Embed_Video_URL
//         Intro_Content
//         Tile_Image {
//             url
//         }
//     }
// }
// `;

const Owners=(props)=>{

    // const { loading, error, data } = useQuery(SINGLE_AREA, {
    //     variables: { Prop_Postcode: props.postcode }
    // });

    // console.log("image",props.property_owners_image)



  const data = useStaticQuery(graphql`
  query{
    allStrapiAreaGuides(filter: {Postcode: {ne: null}, Publish: {eq: true}}) {
        edges {
          node {
            Title
            Postcode
            URL
            Embed_Video_URL
            Intro_Content
            Tile_Image {
                internal {
                  description
                }
            }
            id
            strapiId
            imagetransforms {
                Tile_Image_Transforms
            }
          }
        }
      }
  }
`);


// Several guides can share an outcode (e.g. N6), so prefer the one named in the property's address
let matchingAreas = data.allStrapiAreaGuides.edges.filter(item => _.includes(item.node.Postcode.split(",").map(code => code.trim()),props.postcode));
let address = (props.display_address || "").toLowerCase();
let Postcode = (matchingAreas.find(item => item.node.Title && address.includes(item.node.Title.toLowerCase())) || _.last(matchingAreas))?.node;

let area_image_url = ''
if(Postcode) {
    area_image_url = Postcode?.Tile_Image?.internal?.description ? Postcode.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';
}

let area_processedImages = JSON.stringify({});
if (Postcode?.imagetransforms?.Tile_Image_Transforms) {
    area_processedImages = Postcode.imagetransforms.Tile_Image_Transforms;
}

    return(
        <>
            <section className="two-clm-sec area-guide-wrap">
                    {Postcode &&
                    <div id="new_homes_video" className="new-homes-area-guide">
                        
                    <Container id="detailsFeatures">
                                    <InView {...inViewOptions}>
                                        {({ ref, inView }) => (
                                            <>
                                                <MotionRow
                                                    className="sec-rw sec-rw4 align-items-xl-center"
                                                    ref={ref}
                                                    initial="hidden"
                                                    animate={inView ? "visible" : "hidden"}
                                                    variants={containerVariants}
                                                >
                                                    <Col lg={6}>
                                                        <motion.div
                                                            className="view view02"
                                                            variants={fromLeft}
                                                        >
                                                            {area_image_url &&
                                                            <ImageTransform imagesources={area_image_url} renderer="srcSet" imagename="area-guides.Tile_Image.tile" attr={{ alt: Postcode.property_title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={area_processedImages} id={Postcode.strapiId}/>
                                                            }
                                                            <PropertyDetailsModal url={Postcode.Embed_Video_URL} />
                                                        </motion.div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <motion.div
                                                            className="details guide-area"
                                                            variants={fromRight}
                                                        >
                                                            {Postcode.Title &&
                                                            <h2 className="sec-title">{Postcode.Title} Area Guide</h2>
                                                            }
                                                            {Postcode.Intro_Content &&
                                                            <p className="desc-txt">{HTMLParser(Postcode.Intro_Content)}</p>
                                                            }
                                                            {Postcode.URL &&
                                                            <Link to={`/about/area-guides/${Postcode.URL}`} className="btn btn-success d-block d-md-inline-block">view area guide</Link>
                                                            }
                                                        </motion.div>
                                                    </Col>
                                                </MotionRow>
                                            </>
                                        )}
                                    </InView>
                                    </Container>
                    </div>
                }
                </section>
                <section className="two-clm-sec">
                {props.tag == "new-homes" ?
                    <Availability id={props.crm_id}/>
                    : ''
                }
                {props.tag == "new-homes" ?
                    <InView {...inViewOptions}>
                        {({ ref, inView }) => (
                            <motion.div
                                className="property-map-newhomes" id="property-map"
                                ref={ref}
                                initial="hidden"
                                animate={inView ? "visible" : "hidden"}
                                variants={containerVariants}
                            > <div className='click-map-cta-block new-homes'>
                            <Container>
                            <div className='cta-title'>
                            Click on the map pin to get <span>directions/plan your journey</span>
                            </div>
                            </Container>
                            </div>
                                <Map lat={props.latitude} log={props.longitude} page="property"/>
                            </motion.div>
                        )}
                    </InView>
                    :
                    <InView {...inViewOptions}>
                        {({ ref, inView }) => (
                            <motion.div
                                id="property-map"
                                ref={ref}
                                initial="hidden"
                                animate={inView ? "visible" : "hidden"}
                                variants={containerVariants}
                            >
                                <div className='click-map-cta-block'>
                                    <Container>
                                    <div className='cta-title'>
                                    Click on the map pin to get <span>directions/plan your journey</span>
                                    </div>
                                    </Container>
                                    </div>
                                <Map lat={props.latitude} log={props.longitude} mapview={props.mapview} page="property"/>
                            </motion.div>
                        )}
                    </InView>
                }

                
                {/* <ScrollAnimation animateIn='fadeInUp' animateOnce>
                <Container id="new_homes_video">
                    <Row className="sec-rw sec-rw4 align-items-xl-center">
                        <Col lg={6}>
                            <div className="view view02">
                                <img loading="lazy" src={propImg07} alt="Image" />
                                <strong className="play-btn"><i className="icon-play-icon"></i></strong>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="details guide-area">
                                <h2 className="sec-title">Mill Hill Area Guide</h2>
                                <p className="desc-txt">Mill Hill is a leafy London suburb with Edgware to its west and Finchley to its east, Totteridge and Barnet to the north and Hendon to the south. </p>
                                <p className="desc">Mill Hill is surrounded by open fields and parks including Arrandene open space and Mill Hill park and has some excellent local golf courses.</p>
                                <Link to="#" className="btn btn-success d-block d-md-inline-block">view area guide</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
                </ScrollAnimation> */}

            </section>
        </>
    )
}

export default Owners